import DriverPayrollComponent from './drivers/DriverPayroll';

export default DriverPayrollComponent;
